/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { ProtocolSectionArgs } from "../../base-components/base-protocol-item";

import templateOnly, { type TOC } from "@ember/component/template-only";
const TreatmentHistoryDefaultChemotherapyComponent: TOC<ProtocolSectionArgs> =
  templateOnly();
export default TreatmentHistoryDefaultChemotherapyComponent;
